import React from 'react'
import { Modal, ModalHeader, Button } from 'reactstrap';
import { FormRack } from './FormRack';
import { Dialog } from 'primereact/dialog';

export const ModalRack = (props) => {

    const {
        modal, modalTitle, closeDialog, method, loading,
        name, code, slots, handleInputChange, validaciones,
        saveCreate, saveUpdate
    } = props;

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end" }}>


            <Button
                color="secondary"
                size="sm"
                disabled={loading}
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                {
                                    method === "create"
                                        ? "Guardando..."
                                        : "Actualizando..."
                                }
                            </>
                        )
                        : (
                            method === "create"
                                ? "Guardar"
                                : "Actualizar"
                        )
                }
            </Button>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

        </div>
    );

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            blockScroll
            footer={footer}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-cube f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v2`}



        >
            {
                method === "create"
                    ? <FormRack button={"Guardar gradilla"} {...{ loading, handleInputChange, validaciones, methodAction: saveCreate }} />
                    : (method === "update")
                        ? <FormRack button={"Actualizar gradilla"} {...{ loading, handleInputChange, validaciones, methodAction: saveUpdate, name, code, slots }} />
                        : null
            }
        </Dialog>
    )
}
